'use client';

import type { ComponentProps, ReactNode } from 'react';
import { ZoneLink } from '@/lib/components/ZoneLink';

interface SearchLinkProps extends Pick<ComponentProps<'a'>, 'id' | 'role'> {
  /** Locale-less path, e.g. `/event/…`, `/news/…`, `/trade/…`. */
  href: string;
  onClick?: () => void;
  className?: string;
  children: ReactNode;
}

/**
 * A result's link. The search runs in every zone (markets, news, trade), so a
 * target in another zone is a full load. Clicks are credited to the search in
 * the navigation analytics.
 */
export function SearchLink({ href, onClick, className, children, ...rest }: SearchLinkProps) {
  return (
    <ZoneLink
      href={href}
      onClick={onClick}
      className={className}
      data-nav-source="search"
      {...rest}
    >
      {children}
    </ZoneLink>
  );
}
